import React, { useState } from "react";
import { API } from "../lib/api";
import ModelPicker from "./ModelPicker";

const modes = [
  { k: "draft_resolution", label: "Draft Resolution" },
  { k: "summarize_minutes", label: "Summarize Minutes" },
  { k: "suggest_edits", label: "Suggest Edits" },
  { k: "freeform", label: "Freeform" },
];

export default function AiPanel() {
  const [mode, setMode] = useState("draft_resolution");
  const [model, setModel] = useState("claude");
  const [prompt, setPrompt] = useState("");
  const [ctx, setCtx] = useState("");
  const [out, setOut] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true); setOut("");
    const r = await fetch(`${API}/ai/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json",
                 Authorization: `Bearer ${localStorage.getItem("ehu_token")}` },
      body: JSON.stringify({ mode, prompt, context: ctx, model })
    });
    const reader = r.body.getReader();
    const dec = new TextDecoder();
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      setOut(prev => prev + dec.decode(value, { stream: true }));
    }
    setBusy(false);
  };

  return (
    <div className="p-4 space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <div className="label-caps mb-1">Mode</div>
          <select value={mode} onChange={e=>setMode(e.target.value)} data-testid="ai-mode">
            {modes.map(m => <option key={m.k} value={m.k}>{m.label}</option>)}
          </select>
        </div>
        <div>
          <div className="label-caps mb-1">AI Model</div>
          <ModelPicker value={model} onChange={setModel} testid="ai-model-picker" />
        </div>
      </div>
      <div>
        <div className="label-caps mb-1">Context (optional)</div>
        <textarea rows={3} value={ctx} onChange={e=>setCtx(e.target.value)} data-testid="ai-context"
          placeholder="Paste a snippet the assistant should work from…" />
      </div>
      <div>
        <div className="label-caps mb-1">Your ask</div>
        <textarea rows={3} value={prompt} onChange={e=>setPrompt(e.target.value)} data-testid="ai-prompt"
          placeholder="e.g. Draft a resolution to appoint an enforcer for the Grove Keeper trust." />
      </div>
      <button className="btn-primary" onClick={run} disabled={busy || !prompt} data-testid="ai-run">
        {busy ? "Streaming…" : "Ask"}
      </button>
      {out && (
        <div className="mt-3 p-3 border rounded" style={{borderColor:'var(--border)', background:'var(--surface-2)'}}>
          <div className="label-caps mb-1">Assistant</div>
          <pre className="whitespace-pre-wrap text-sm font-serif-body">{out}</pre>
        </div>
      )}
    </div>
  );
}
